import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTable, useSortBy, usePagination } from "react-table";
import { OrderTableProps } from '../../lib/Interfaces/OrderTableProps';
import { store } from '../..';
import { ApplicationState } from '../../store';
import { useNavigate } from 'react-router-dom';
import { Form, Button, ButtonBar, Heading, Box, InlineInputs, FilterableSelect, Option } from '../../lib/carbon-ui';
import axiosService from '../../lib/Axios';
import { AxiosError, AxiosResponse } from "axios";
import DefaultMessage, { IMessageOrToastOptions } from '../../Components/MessageOrToast/DefaultMessage';
import './ExecutePage.css';
import { OrdersLoadedModel } from '../../lib/Interfaces/OrdersModel';
import { SubmitDropsModel } from '../../lib/Interfaces/SubmitDropsModel'
import { SubmitDropsError } from '../../lib/Interfaces/SubmitDropsError'
import { SubmitDropsWarning } from '../../lib/Interfaces/SubmitDropsWarning'
import { DropDown } from '../../lib/Interfaces/DropDown';
import GetDepotsForDropDownResponse from '../../lib/Interfaces/GetDepotsForDropDownResponse';
//import { SubmitDropsResponse } from '../../lib/Interfaces/SubmitDropsResponse';
//import { returnDistinctOrderNumbersFromOrderItemsCollection } from '../RequestPage/RequestPage';
import { error } from 'console';
import { SubmitDropsFailed } from '../../lib/Interfaces/SubmitDropsFailed';
import { SubmitDropsSuccess } from '../../lib/Interfaces/SubmitDropsSuccess';
import { MaxOptraInterface } from '../../lib/Interfaces/MaxOptraInterface';

const ExecutePage = () => 
{
  const navigate = useNavigate();
  const emptyOrdersLoadedModel: OrdersLoadedModel[] = [];
  const emptySubmitDropsModel: SubmitDropsModel[] = [];
  const emptySubmitDropsWarning: SubmitDropsWarning[] = [];
  const emptySubmitDropsError: SubmitDropsError[] = [];
  const emptySubmitDropsFailed: SubmitDropsFailed[] = [];
  const emptySubmitDropsSuccess: SubmitDropsSuccess[] = [];

  const [listOfAllOrdersArray, setListOfAllOrdersArray] = useState<string[]>([]);
  const [listOfAllOrdersPulledIn, setListOfAllOrdersPulledIn] = useState<OrdersLoadedModel[]>([]);
  const [listOfAllDropsProcessed, setListOfAllDropsProcessed] = useState<SubmitDropsModel[]>([]);
  const [listOfAllDropWarnings, setListOfAllDropWarnings] = useState<SubmitDropsWarning[]>([]);
  const [listOfAllDropErrors, setListOfAllDropError] = useState<SubmitDropsError[]>([]);
  const [listOfAllDropsFailed, setListOfAllDropsFailed] = useState<SubmitDropsFailed[]>([]);
  const [listOfAllDropsSuccess, setListOfAllDropsSuccess] = useState<SubmitDropsSuccess[]>([]);

  const userIsAuthenticated = useSelector((state: ApplicationState) => state.authenticationState.authSettings?.isAuthenticated);
  const [messageBoxIsOpen, setMessageBoxIsOpen] = useState<boolean>(false);
  const [messageBoxVariant, setMessageBoxVariant] = useState<string>("success");
  const [messageBoxTitle, setMessageBoxTitle] = useState<string>("");
  const [messageBoxMessage, setMessageBoxMessage] = useState<string>("");

  const [showGeneratingMessage, setShowGeneratingMessage] = useState<boolean>(false);
  const [showSuccessTable, setShowSuccessTable] = useState<boolean>(false);

  // Get the Depots and set the default
  const [selectedDepot, setSelectedDepot] = useState<string>("All Depots");
  const [allDepots, setAllDepots] = useState<DropDown[]>();
  
  //RealitexID of user submitting requeest
  const userSubmittingRequest = store.getState().authenticationState.authSettings?.realitexUserName;

  const errorMessageBoxOptions: IMessageOrToastOptions = 
  {
    isOpen: messageBoxIsOpen,
    variant: messageBoxVariant,
    title: messageBoxTitle,
    message: messageBoxMessage,
  };

  const [importMaxoptraJobsButtonText, setImportMaxoptraJobsButtonText] = useState<string>("Download From MaxOptra");
  //const [disableImportMaxoptraJobsButton, setDisableImportMaxoptraJobsButton] = useState(false);
  const [executeMaxoptraJobsButtonText, setExecuteMaxoptraJobsButtonText] = useState<string>("Generate Realitex Consignments");
  const [disableExecuteMaxoptraJobsButton, setDisableExecuteMaxoptraJobsButton] = useState(true);


  // An empty dependancy array isn't needed in React version 18 on useEffect hooks
  useEffect(() => {
    if (!userIsAuthenticated) navigate("/");
      // ------------------------------------------------------------------
      // Get list of deopts for the dropdown control
      // ------------------------------------------------------------------
    
      axiosService
      .get(`api/v1/Depot/DepotsForDropDown`) 
      .then(function (response: AxiosResponse<GetDepotsForDropDownResponse>) { 
        const {data} = response;

        // Add 'All Depots' to start of array
        data.depots.unshift({value:"All Depots", key:"All Depots", text:"All Depots"});
        setAllDepots(data.depots);
      });
  }, [])
    
  const handleChangedDepot = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDepot(event.target.value);
  }

  
  const resetState = () => 
  {
    setMessageBoxVariant("success");
    setMessageBoxTitle("");
    setMessageBoxMessage("");
    setMessageBoxIsOpen(false);
    setImportMaxoptraJobsButtonText("Download From MaxOptra");
    setExecuteMaxoptraJobsButtonText("Generate Realitex Consignments");
    setDisableExecuteMaxoptraJobsButton(true);
    
    setListOfAllOrdersPulledIn(emptyOrdersLoadedModel);
    setListOfAllDropsProcessed(emptySubmitDropsModel);
    setListOfAllDropsSuccess(emptySubmitDropsSuccess);
    setListOfAllDropsFailed(emptySubmitDropsFailed);
    setListOfAllDropWarnings(emptySubmitDropsWarning);
    setListOfAllDropError(emptySubmitDropsError);
    setShowSuccessTable(false);
    setShowGeneratingMessage(false);
  };

  useEffect(() => {
    if (!userIsAuthenticated) navigate("/");
  }, [userIsAuthenticated, navigate]);

const handleExecuteLoadPage = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) =>
  {
    event.preventDefault();

    // Reset the properties before getting the available data from MaxOptra
    resetState();

    // Construct the api call including the selected depot
    const url = `api/v1/MaxOptra/GetOptimisedOrdersFromMaxOptra?distributionCenter=${encodeURIComponent(selectedDepot)}`;

    axiosService.get(url)
      .then(function(response: AxiosResponse<OrdersLoadedModel[]>) {
        const { data } = response;

        if (data && data.length === 0)
        {
          setMessageBoxIsOpen(true);
          setMessageBoxVariant("warning");
          setMessageBoxTitle("No drops could be found");
          setMessageBoxMessage("There were no drops found loaded and locked.");
        }
        else if (!data)
        {
          setMessageBoxIsOpen(true);
          setMessageBoxVariant("error");
          setMessageBoxTitle("Error getting drops");
          setMessageBoxMessage("There was an error getting the drops from MaxOptra. Please try again later or contact Innov8 for assistance.");
        }
        else
        {
          setMessageBoxIsOpen(false);
          const referenceNumber = data.map(order => order.referenceNumber);
          setListOfAllOrdersArray(referenceNumber);
          setDisableExecuteMaxoptraJobsButton(false);
          setListOfAllOrdersPulledIn(data);
        }
      })
    . catch (function (error) {
      setMessageBoxIsOpen(true);
      setMessageBoxVariant("error");
      setMessageBoxTitle("Error getting drops");
      setMessageBoxMessage("There was an error getting the drops from MaxOptra. Please try again later or contact Innov8 for assistance.");
    });
  }
  
  const handleExecutePage = async (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => 
  {
    try 
    {
      // Disable execute button, need to re-download before attempting again 
      setDisableExecuteMaxoptraJobsButton(true);
      setShowGeneratingMessage(true);
      
      // Call our API to process the drops we got back. 
      // Note MaxOptra refer to each entity as an order where we refer to them as drops as each drop can contain multiple orders.
      const response: AxiosResponse<SubmitDropsModel[]> = 
        await axiosService.post(`api/v1/MaxOptra/SubmitOptimisedOrdersToRealitex?userSubmittingRequest=${userSubmittingRequest}`,listOfAllOrdersArray);

      // Put the response from the API into an object
      const { data } = response;

      // Put the data object into another object to show in a table
      setListOfAllDropsProcessed(data);
      
      let globalErrorCount = 0;
      let globalWarningCount = 0;

      data.forEach((myDrop) =>
      {
        if (myDrop.submitErrors.length > 0)
        {
          // Loop through the errors for this drop 
          myDrop.submitErrors.forEach((submitError) => {
            // Add details to our error list
            var obj = {  
              dropReference: myDrop.dropReference,
              customerName: myDrop.customerName,
              orderNumbers: myDrop.orderNumbers,
              deliveryMethod: myDrop.deliveryMethod,
              errorMessage: submitError
            };
            listOfAllDropErrors.push(obj)
            globalErrorCount++;
          })
        }

        if (myDrop.submitWarnings.length > 0)
        {
          // Loop through the warnings for this drop
          myDrop.submitWarnings.forEach((submitWarning) => {
            // Add details to our warnings list
            var obj = {  
              dropReference: myDrop.dropReference,
              customerName: myDrop.customerName,
              orderNumbers: myDrop.orderNumbers,
              deliveryMethod: myDrop.deliveryMethod,
              errorMessage: submitWarning
            };
            listOfAllDropWarnings.push(obj)
            globalWarningCount++;
          })
        }

        if (myDrop.submitStatus == "Success")
        {
          // Add details to our succcess list
          listOfAllDropsSuccess.push(myDrop);
        }

        if (myDrop.submitStatus != "Success")
          {
            // Add details to our succcess list
            listOfAllDropsFailed.push(myDrop);
          }
      })

      // Alway show success table, even if only to confirm zero consignments were generated
      setShowSuccessTable(true);
      setShowGeneratingMessage(false);

      // No errors or warnings - success!
      if (globalErrorCount === 0 && globalWarningCount === 0)
      {
        setMessageBoxVariant("success");
        setMessageBoxTitle("Success")
        setMessageBoxMessage("All drops successfully imported into Realitex and consignment notes generated.");
        setMessageBoxIsOpen(true);
      }

      // Errors and warnings
      if (globalErrorCount > 0 && globalWarningCount > 0)
      {
        setMessageBoxVariant("error");
        setMessageBoxTitle("FAILED - Some consignments have not been generated and others need attention.")
        setMessageBoxMessage("Some of the drops have errors and some have warnings. Some consignments may have been generated any may need attention. Please see below for details.");
        setMessageBoxIsOpen(true);
        //setDisableImportMaxoptraJobsButton(false);
        return;
      }

      // Warnings but no errors
      if (globalErrorCount === 0 && globalWarningCount > 0)
      {
        setMessageBoxVariant("warning");
        setMessageBoxTitle("Warning - Some consignments will need attention.")
        setMessageBoxMessage("Some of the drops have warnings. Consignments have been generated but will require attention and the import process running again. See below for details.");
        setMessageBoxIsOpen(true)
        //setDisableExecuteMaxoptraJobsButton(false);
        return;
      }

      // Errors but no warnings
      if (globalErrorCount > 0 && globalWarningCount === 0)
      {
        setMessageBoxVariant("error");
        setMessageBoxTitle("FAILED - Some consignments have not been generated.")
        setMessageBoxMessage("Some of the drops have errors. Some consignments may not have been generated. See below for details.");
        setMessageBoxIsOpen(true);
        //setDisableImportMaxoptraJobsButton(false);
        return;
      }
    }
    catch(Error)
    {
      setMessageBoxIsOpen(true);
      setMessageBoxVariant("error");
      setMessageBoxTitle("Error executing drops");
      setMessageBoxMessage("There was an error executing loaded drops on MaxOptra. Please try again later or contact Innov8 for assistance.");
    }
  };
  
  const ImportResponseColumns = React.useMemo(
    () => [
      {
        Header: "Depot",
        accessor: "distributionCentreReference",
      },
      {
        Header: "Account Number",
        accessor: "clientName"
      },
      {
        Header: "Customer Address",
        accessor: "customerLocation.customerName",
      },
      {
        Header: "Delivery Reference",
        accessor: "referenceNumber",
      }
    ],
    []
  );

  const SubmitErrorColumns = React.useMemo(
    () => [
      {
        Header: "Drop Reference",
        accessor: "dropReference",
      },
      {
        Header: "Orders",
        accessor: "orderNumbers",
      },
      {
        Header: "Delivery Method",
        accessor: "deliveryMethod",
      },
      {
        Header: "Details",
        accessor: "errorMessage",
      }
    ],
    []
  );

  const SubmitResponseErrorColumns = React.useMemo(
    () => [
      {
        Header: "Delivery Method",
        accessor: "deliveryMethod",
      },
      {
        Header: "Sequence",
        accessor: "sequenceNumber"
      },
      {
        Header: "Account No",
        accessor: "accountNumber",
      },
      {
        Header: "Customer Address",
        accessor: "customerName"
      },
      {
        Header: "Orders",
        accessor: "orderNumbers",
      },
      {
        Header: "Status",
        accessor: "submitStatus",
      }
    ],
    []
  );

  const SubmitResponseSuccessColumns = React.useMemo(
    () => [
      {
        Header: "Consignment No",
        accessor: "consignmentNumber",
      },
      {
        Header: "Sequence",
        accessor: "sequenceNumber"
      },
      {
        Header: "Account No",
        accessor: "accountNumber",
      },
      {
        Header: "Customer Address",
        accessor: "customerName"
      },
      {
        Header: "Orders",
        accessor: "orderNumbers",
      },
      {
        Header: "Status",
        accessor: "submitStatus",
      }
    ],
    []
  );

  const Table: React.FC<OrderTableProps> = ({ columns, data }) => {
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      page,
      canPreviousPage,
      canNextPage,
      pageOptions,
      pageCount,
      gotoPage,
      nextPage,
      previousPage,
      setPageSize,
      state: { pageIndex, pageSize },
    } = useTable({
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
      useSortBy,
      usePagination
    );

    return (
      <>
        <table width="100%" {...getTableProps()}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render('Header')}
                    <span>
                      {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="pagination">
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {'<<'}
          </button>{' '}
          {/* Commented out because these 2 buttons redirect to the login page 
          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            {'<'}
          </button>{' '}
          <button onClick={() => nextPage()} disabled={!canNextPage}>
            {'>'}
          </button>{' '} */}
          <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {'>>'}
          </button>{' '}
          <span>
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
          </span>
          <span>
            | Go to page:{' '}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={e => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0
                gotoPage(page)
              }}
              style={{ width: '100px' }}
            />
          </span>{' '}
          <select
            value={pageSize}
            onChange={e => {
              setPageSize(Number(e.target.value))
            }}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>      
      </>

    );
  };

  return (
    <Form onSubmit={() => {}} fieldSpacing={4}>

    <div className="myPage">
      <Heading title="Download From MaxOptra" mt={2}></Heading>
        <Box ml="25%" mr="25%" >
          <InlineInputs gutter="medium">
            <FilterableSelect 
              size="medium"
              name="isLoading" 
              id="isLoading" 
              label="Depot:" 
              onChange={handleChangedDepot} 
              value={selectedDepot}>
              {
                allDepots && allDepots.length > 0 ?
                  allDepots.map((element, index) => {
                    return (
                      <Option text={element.text} value={element.value} key={index} />
                    )
                  })
                : 
                null
              }
            </FilterableSelect>
          </InlineInputs>
        </Box>

      <div className = "buttonTable">
        <ButtonBar fullWidth ml={2} mt={2}>
          <Button buttonType="primary" 
            onClick={handleExecuteLoadPage} disabled={false}> {importMaxoptraJobsButtonText}
          </Button>
          <Button buttonType="primary" 
            onClick={handleExecutePage} disabled={disableExecuteMaxoptraJobsButton}> {executeMaxoptraJobsButtonText}
          </Button>
        </ButtonBar> 
      </div>

      <div className="StatusMessageBox">
        <DefaultMessage messageOptions={errorMessageBoxOptions} />
      </div>

      <div id="Tables" className="Tables">

        <div id="ImportResponse" >
          {
            (listOfAllOrdersPulledIn && listOfAllOrdersPulledIn.length > 0) && (listOfAllDropsProcessed.length === 0) ?
            <div id="ImportSuccessTable">
              <div className="MessageBox">
                <h3>Retrieved {listOfAllOrdersPulledIn.length} drops to import</h3>
              </div>
              <div className="myTable">
                <Table columns={ImportResponseColumns} data={listOfAllOrdersPulledIn} />
              </div>
            </div>
              :
              null  
          }
        </div>

        <br></br>

        <div id="SubmitError">
          {
            (listOfAllDropErrors && listOfAllDropErrors.length > 0) ?
              <div id="SubmitErrorTable">
                <div className="MessageBox">
                  <h3>Encountered {listOfAllDropErrors.length} errors</h3>
                </div>
                <div className="myTable">
                  <Table columns={SubmitErrorColumns} data={listOfAllDropErrors} />
                </div>
              </div>
              :
              null  
          }
        </div>

        <br></br>

        <div id="SubmitWarning">
          {
            (listOfAllDropWarnings && listOfAllDropWarnings.length > 0) ?
              <div id="SubmitWarningsTable">
                <div className="MessageBox">
                  <h3>Detected {listOfAllDropWarnings.length} warnings</h3>
                </div>
                <div className="myTable">
                  <Table columns={SubmitErrorColumns} data={listOfAllDropWarnings} />
                </div>
              </div>
              :
              null  
          }
        </div>

        <br></br>

        <div id="SubmitFailed" className="">
          {
             (listOfAllDropsFailed && listOfAllDropsFailed.length > 0) ?
              <div id="SubmitFailedTable">
                <div className="MessageBox">
                  <h3>Failed to generate consignments for {listOfAllDropsFailed.length} drops</h3>
                </div>
                <div className="myTable">
                  <Table columns={SubmitResponseErrorColumns} data={listOfAllDropsFailed} />
                </div>
              </div>
               :
               null  
          }
        </div>

        <br></br>

        <div id="GeneratingConsignments" className="">
          {
            (showGeneratingMessage && showGeneratingMessage == true) ?
              <div className="MessageBox">
                <h3>Generating consignments for {listOfAllOrdersPulledIn.length} drops...</h3>
              </div>
            :
              null
          }
        </div>

        <div id="SubmitSuccess" className="">
          {
            (showSuccessTable && showSuccessTable == true) ?
              <div id="SubmitSuccessTable">
                <div className="MessageBox">
                  <h3>Generated consignments for {listOfAllDropsSuccess.length} drops</h3>
                </div>
                <div className="myTable">
                  <Table columns={SubmitResponseSuccessColumns} data={listOfAllDropsSuccess} />
                </div>
              </div>
            :
              null
          }
        </div>

      </div>
      </div>
    </Form>
  );
};

export default ExecutePage;